import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Freon Scoper Definition",
description: "Learn how to write a Freon scoper definition in .scope files, declare namespaces, and define imports and alternatives using Freon’s scoping meta-language.",
tags: [ "scoper definition", "scope provider", ".scope", "namespaces", "imports", "alternatives", "meta-language", "scoping rules", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:52:21.430Z",
publishedTime: "2025-11-07T17:20:18.624Z"
    }
  };
};